import predicates from '../predicates'
import selectors from '../selectors'
import { INFLUENCER_TRAFFIC_SOURCE } from '../constants'

const influencer = {
  rule: predicates.or(
    predicates.searchParamsIncludeOne('a_aid'),
    predicates.and(
      predicates.pathnameIncludesOne('partners'),
      predicates.pathnameIncludesAfterKey('partners')
    )
  ),
  extractor: traffic => {
    const trafficSource = INFLUENCER_TRAFFIC_SOURCE
    const trafficId =
      selectors.searchParamValue(traffic, 'a_aid') ||
      selectors.afterPathnameKey(traffic, 'partners')

    return {
      trafficSource,
      trafficId,
    }
  },
}

export default influencer



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/pipelines/influencer.js